'use client';

import type { ForwardedRef } from 'react';
import { forwardRef } from '../../forward-ref.js';
import { Checkbox } from '../checkbox/checkbox.js';
import type { CommonProps, LabellableProps } from '../types.js';
import { useTableRowState } from './contexts/row-state.js';
import { useTableState } from './contexts/table-state.js';

export interface TableRowSelectorProps extends CommonProps, Omit<LabellableProps, 'label'> {}

function TableRowSelector(props: TableRowSelectorProps, ref: ForwardedRef<HTMLLabelElement>) {
  const { rowSelectionMode } = useTableState();
  const { isSelected, onSelectionToggle } = useTableRowState();

  if (rowSelectionMode === 'none') {
    return null;
  }

  return <Checkbox {...props} ref={ref} isSelected={isSelected} onChange={onSelectionToggle} />;
}

/**
 * Controls the selection state of a single row within a table.
 *
 * See [table building guide](https://ui.cimpress.io/dev-guides/tables/).
 */
const _TableRowSelector = forwardRef(TableRowSelector, 'TableRowSelector');

export { _TableRowSelector as TableRowSelector };
